export const BASE = {
  name: 'invite-teammate',
  path: '/sites/:siteId/invite-teammate',
};
